import { useHotKeys, useHotKeyTooltipChange } from '@mti/multitenant-ui-shared';

export const hotKeys = {
  DISPLAY_HOTKEYS: 'F9',
  SEARCH_BOOKINGS: 'Control+s',
};

export const HotKeys = () => {
  const [hotkeyToggle] = useHotKeyTooltipChange();

  useHotKeys(hotKeys.DISPLAY_HOTKEYS, () => {
    hotkeyToggle();
  });

  useHotKeys(hotKeys.SEARCH_BOOKINGS, () => {
    window['setSearchOpen'] && window['setSearchOpen']();
  });

  return null;
};
